export function useMessages() {
    const show_error=async (e:any) => {
        const message=e?.response?._data?.message || e?.message || e?.data?.message;
        const title=e?.response?._data?.title || e?.title || '';
        await ElMessageBox.alert(message,
            {
                title: title,
                type: 'error',
                confirmButtonText: 'OK',
                confirmButtonClass: 'el-button--danger',
                showCancelButton: false,
                appendTo:'body'
            })
    }

    const show_success=async (message: string) => {
        ElNotification.success({
            message:message,
            customClass:"primary-success"
        });
    }

    return {show_error,show_success}
}